const inAColors = [
  {
    "primary": {
      "0": "rgb(230, 241, 251)",
      "50": "rgb(229, 241, 251)",
      "100": "rgb(204, 227, 248)",
      "200": "rgb(179, 212, 244)",
      "300": "rgb(153, 198, 241)",
      "400": "rgb(128, 184, 237)",
      "500": "rgb(102, 170, 233)",
      "600": "rgb(77, 156, 230)",
      "700": "rgb(51, 141, 226)",
      "800": "rgb(26, 127, 223)",
      "900": "rgb(0, 113, 219)",
      "950": "rgb(0, 7, 17)"
    },
    "mark": {
      "900": "rgb(214, 0, 0)"
    },
    "secondary": {
      "0": "rgb(252, 252, 252)",
      "50": "rgb(252, 253, 254)",
      "100": "rgb(243, 244, 246)",
      "200": "rgb(228, 231, 235)",
      "300": "rgb(209, 213, 218)",
      "400": "rgb(156, 163, 175)",
      "500": "rgb(107, 114, 128)",
      "600": "rgb(75, 85, 99)",
      "700": "rgb(55, 65, 81)",
      "800": "rgb(31, 41, 55)",
      "900": "rgb(17, 24, 39)",
      "950": "rgb(0, 0, 0)"
    },
    "tertiary": {
      "0": "rgb(255, 250, 245)",
      "50": "rgb(255, 242, 229)",
      "100": "rgb(255, 233, 213)",
      "200": "rgb(254, 209, 170)",
      "300": "rgb(253, 180, 116)",
      "400": "rgb(251, 157, 75)",
      "500": "rgb(231, 129, 40)",
      "600": "rgb(215, 117, 31)",
      "700": "rgb(180, 98, 26)",
      "800": "rgb(130, 73, 23)",
      "900": "rgb(108, 61, 19)",
      "950": "rgb(84, 49, 18)"
    },
    "error": {
      "0": "rgb(254, 233, 233)",
      "50": "rgb(254, 226, 226)",
      "100": "rgb(254, 202, 202)",
      "200": "rgb(252, 165, 165)",
      "300": "rgb(248, 113, 113)",
      "400": "rgb(239, 68, 68)",
      "500": "rgb(230, 53, 53)",
      "600": "rgb(220, 38, 38)",
      "700": "rgb(185, 28, 28)",
      "800": "rgb(127, 29, 29)",
      "900": "rgb(153, 27, 27)",
      "950": "rgb(34, 8, 8)"
    },
    "success": {
      "0": "rgb(228, 255, 244)",
      "50": "rgb(202, 255, 232)",
      "100": "rgb(162, 241, 192)",
      "200": "rgb(132, 211, 162)",
      "300": "rgb(102, 181, 132)",
      "400": "rgb(72, 151, 102)",
      "500": "rgb(52, 131, 82)",
      "600": "rgb(42, 121, 72)",
      "700": "rgb(32, 111, 62)",
      "800": "rgb(22, 101, 52)",
      "900": "rgb(20, 83, 45)",
      "950": "rgb(27, 50, 36)"
    },
    "warning": {
      "0": "rgb(255, 249, 245)",
      "50": "rgb(255, 244, 236)",
      "100": "rgb(255, 231, 213)",
      "200": "rgb(254, 205, 170)",
      "300": "rgb(253, 173, 116)",
      "400": "rgb(251, 149, 75)",
      "500": "rgb(231, 120, 40)",
      "600": "rgb(215, 108, 31)",
      "700": "rgb(180, 90, 26)",
      "800": "rgb(130, 68, 23)",
      "900": "rgb(108, 56, 19)",
      "950": "rgb(84, 45, 18)"
    },
    "info": {
      "0": "rgb(236, 248, 254)",
      "50": "rgb(199, 235, 252)",
      "100": "rgb(162, 221, 250)",
      "200": "rgb(124, 207, 248)",
      "300": "rgb(87, 194, 246)",
      "400": "rgb(50, 180, 244)",
      "500": "rgb(13, 166, 242)",
      "600": "rgb(11, 141, 205)",
      "700": "rgb(9, 115, 168)",
      "800": "rgb(7, 90, 131)",
      "900": "rgb(5, 64, 93)",
      "950": "rgb(3, 38, 56)"
    },
    "typography": {
      "0": "rgb(254, 254, 255)",
      "50": "rgb(245, 245, 245)",
      "100": "rgb(229, 229, 229)",
      "200": "rgb(219, 219, 220)",
      "300": "rgb(212, 212, 212)",
      "400": "rgb(163, 163, 163)",
      "500": "rgb(140, 140, 140)",
      "600": "rgb(115, 115, 115)",
      "700": "rgb(82, 82, 82)",
      "800": "rgb(64, 64, 64)",
      "900": "rgb(38, 38, 39)",
      "950": "rgb(23, 23, 23)"
    },
    "outline": {
      "0": "rgb(253, 254, 254)",
      "50": "rgb(243, 243, 243)",
      "100": "rgb(230, 230, 230)",
      "200": "rgb(221, 220, 219)",
      "300": "rgb(211, 211, 211)",
      "400": "rgb(165, 163, 163)",
      "500": "rgb(140, 141, 141)",
      "600": "rgb(115, 116, 116)",
      "700": "rgb(83, 82, 82)",
      "800": "rgb(65, 65, 65)",
      "900": "rgb(39, 38, 36)",
      "950": "rgb(26, 23, 23)"
    },
    "background": {
      "0": "rgb(255, 255, 255)",
      "50": "rgb(246, 246, 246)",
      "100": "rgb(242, 241, 241)",
      "200": "rgb(220, 219, 219)",
      "300": "rgb(213, 212, 212)",
      "400": "rgb(162, 163, 163)",
      "500": "rgb(142, 142, 142)",
      "600": "rgb(116, 116, 116)",
      "700": "rgb(83, 82, 82)",
      "800": "rgb(65, 64, 64)",
      "900": "rgb(39, 38, 37)",
      "950": "rgb(18, 18, 18)",
      "error": "rgb(254, 241, 241)",
      "warning": "rgb(255, 243, 234)",
      "success": "rgb(237, 252, 242)",
      "muted": "rgb(247, 248, 247)",
      "info": "rgb(235, 248, 254)"
    },
    "indicator": {
      "primary": "rgb(55, 55, 55)",
      "info": "rgb(83, 153, 236)",
      "error": "rgb(185, 28, 28)"
    }
  },
  {
    "primary": {
      "0": "rgb(230, 241, 251)",
      "50": "rgb(244, 249, 230)",
      "100": "rgb(233, 244, 204)",
      "200": "rgb(223, 238, 179)",
      "300": "rgb(212, 233, 153)",
      "400": "rgb(201, 227, 128)",
      "500": "rgb(190, 221, 102)",
      "600": "rgb(179, 216, 77)",
      "700": "rgb(169, 210, 51)",
      "800": "rgb(158, 205, 26)",
      "900": "rgb(147, 199, 0)",
      "950": "rgb(0, 7, 17)"
    },
    "mark": {
      "900": "rgb(0, 113, 219)"
    },
    "secondary": {
      "0": "rgb(252, 252, 252)",
      "50": "rgb(252, 253, 254)",
      "100": "rgb(243, 244, 246)",
      "200": "rgb(228, 231, 235)",
      "300": "rgb(209, 213, 218)",
      "400": "rgb(156, 163, 175)",
      "500": "rgb(107, 114, 128)",
      "600": "rgb(75, 85, 99)",
      "700": "rgb(55, 65, 81)",
      "800": "rgb(31, 41, 55)",
      "900": "rgb(17, 24, 39)",
      "950": "rgb(0, 0, 0)"
    },
    "tertiary": {
      "0": "rgb(255, 250, 245)",
      "50": "rgb(255, 242, 229)",
      "100": "rgb(255, 233, 213)",
      "200": "rgb(254, 209, 170)",
      "300": "rgb(253, 180, 116)",
      "400": "rgb(251, 157, 75)",
      "500": "rgb(231, 129, 40)",
      "600": "rgb(215, 117, 31)",
      "700": "rgb(180, 98, 26)",
      "800": "rgb(130, 73, 23)",
      "900": "rgb(108, 61, 19)",
      "950": "rgb(84, 49, 18)"
    },
    "error": {
      "0": "rgb(254, 233, 233)",
      "50": "rgb(254, 226, 226)",
      "100": "rgb(254, 202, 202)",
      "200": "rgb(252, 165, 165)",
      "300": "rgb(248, 113, 113)",
      "400": "rgb(239, 68, 68)",
      "500": "rgb(230, 53, 53)",
      "600": "rgb(220, 38, 38)",
      "700": "rgb(185, 28, 28)",
      "800": "rgb(127, 29, 29)",
      "900": "rgb(153, 27, 27)",
      "950": "rgb(34, 8, 8)"
    },
    "success": {
      "0": "rgb(228, 255, 244)",
      "50": "rgb(202, 255, 232)",
      "100": "rgb(162, 241, 192)",
      "200": "rgb(132, 211, 162)",
      "300": "rgb(102, 181, 132)",
      "400": "rgb(72, 151, 102)",
      "500": "rgb(52, 131, 82)",
      "600": "rgb(42, 121, 72)",
      "700": "rgb(32, 111, 62)",
      "800": "rgb(22, 101, 52)",
      "900": "rgb(20, 83, 45)",
      "950": "rgb(27, 50, 36)"
    },
    "warning": {
      "0": "rgb(255, 249, 245)",
      "50": "rgb(255, 244, 236)",
      "100": "rgb(255, 231, 213)",
      "200": "rgb(254, 205, 170)",
      "300": "rgb(253, 173, 116)",
      "400": "rgb(251, 149, 75)",
      "500": "rgb(231, 120, 40)",
      "600": "rgb(215, 108, 31)",
      "700": "rgb(180, 90, 26)",
      "800": "rgb(130, 68, 23)",
      "900": "rgb(108, 56, 19)",
      "950": "rgb(84, 45, 18)"
    },
    "info": {
      "0": "rgb(236, 248, 254)",
      "50": "rgb(199, 235, 252)",
      "100": "rgb(162, 221, 250)",
      "200": "rgb(124, 207, 248)",
      "300": "rgb(87, 194, 246)",
      "400": "rgb(50, 180, 244)",
      "500": "rgb(13, 166, 242)",
      "600": "rgb(11, 141, 205)",
      "700": "rgb(9, 115, 168)",
      "800": "rgb(7, 90, 131)",
      "900": "rgb(5, 64, 93)",
      "950": "rgb(3, 38, 56)"
    },
    "typography": {
      "0": "rgb(254, 254, 255)",
      "50": "rgb(245, 245, 245)",
      "100": "rgb(229, 229, 229)",
      "200": "rgb(219, 219, 220)",
      "300": "rgb(212, 212, 212)",
      "400": "rgb(163, 163, 163)",
      "500": "rgb(140, 140, 140)",
      "600": "rgb(115, 115, 115)",
      "700": "rgb(82, 82, 82)",
      "800": "rgb(64, 64, 64)",
      "900": "rgb(38, 38, 39)",
      "950": "rgb(23, 23, 23)"
    },
    "outline": {
      "0": "rgb(253, 254, 254)",
      "50": "rgb(243, 243, 243)",
      "100": "rgb(230, 230, 230)",
      "200": "rgb(221, 220, 219)",
      "300": "rgb(211, 211, 211)",
      "400": "rgb(165, 163, 163)",
      "500": "rgb(140, 141, 141)",
      "600": "rgb(115, 116, 116)",
      "700": "rgb(83, 82, 82)",
      "800": "rgb(65, 65, 65)",
      "900": "rgb(39, 38, 36)",
      "950": "rgb(26, 23, 23)"
    },
    "background": {
      "0": "rgb(255, 255, 255)",
      "50": "rgb(246, 246, 246)",
      "100": "rgb(242, 241, 241)",
      "200": "rgb(220, 219, 219)",
      "300": "rgb(213, 212, 212)",
      "400": "rgb(162, 163, 163)",
      "500": "rgb(142, 142, 142)",
      "600": "rgb(116, 116, 116)",
      "700": "rgb(83, 82, 82)",
      "800": "rgb(65, 64, 64)",
      "900": "rgb(39, 38, 37)",
      "950": "rgb(18, 18, 18)",
      "error": "rgb(254, 241, 241)",
      "warning": "rgb(255, 243, 234)",
      "success": "rgb(237, 252, 242)",
      "muted": "rgb(247, 248, 247)",
      "info": "rgb(235, 248, 254)"
    },
    "indicator": {
      "primary": "rgb(55, 55, 55)",
      "info": "rgb(83, 153, 236)",
      "error": "rgb(185, 28, 28)"
    }
  },
  {
    "primary": {
      "0": "rgb(230, 241, 251)",
      "50": "rgb(255, 250, 230)",
      "100": "rgb(255, 244, 204)",
      "200": "rgb(255, 239, 179)",
      "300": "rgb(255, 233, 153)",
      "400": "rgb(255, 228, 128)",
      "500": "rgb(255, 222, 103)",
      "600": "rgb(255, 217, 77)",
      "700": "rgb(255, 211, 52)",
      "800": "rgb(255, 206, 26)",
      "900": "rgb(255, 200, 1)",
      "950": "rgb(0, 7, 17)"
    },
    "mark": {
      "900": "rgb(147, 199, 0)"
    },
    "secondary": {
      "0": "rgb(252, 252, 252)",
      "50": "rgb(252, 253, 254)",
      "100": "rgb(243, 244, 246)",
      "200": "rgb(228, 231, 235)",
      "300": "rgb(209, 213, 218)",
      "400": "rgb(156, 163, 175)",
      "500": "rgb(107, 114, 128)",
      "600": "rgb(75, 85, 99)",
      "700": "rgb(55, 65, 81)",
      "800": "rgb(31, 41, 55)",
      "900": "rgb(17, 24, 39)",
      "950": "rgb(0, 0, 0)"
    },
    "tertiary": {
      "0": "rgb(255, 250, 245)",
      "50": "rgb(255, 242, 229)",
      "100": "rgb(255, 233, 213)",
      "200": "rgb(254, 209, 170)",
      "300": "rgb(253, 180, 116)",
      "400": "rgb(251, 157, 75)",
      "500": "rgb(231, 129, 40)",
      "600": "rgb(215, 117, 31)",
      "700": "rgb(180, 98, 26)",
      "800": "rgb(130, 73, 23)",
      "900": "rgb(108, 61, 19)",
      "950": "rgb(84, 49, 18)"
    },
    "error": {
      "0": "rgb(254, 233, 233)",
      "50": "rgb(254, 226, 226)",
      "100": "rgb(254, 202, 202)",
      "200": "rgb(252, 165, 165)",
      "300": "rgb(248, 113, 113)",
      "400": "rgb(239, 68, 68)",
      "500": "rgb(230, 53, 53)",
      "600": "rgb(220, 38, 38)",
      "700": "rgb(185, 28, 28)",
      "800": "rgb(127, 29, 29)",
      "900": "rgb(153, 27, 27)",
      "950": "rgb(34, 8, 8)"
    },
    "success": {
      "0": "rgb(228, 255, 244)",
      "50": "rgb(202, 255, 232)",
      "100": "rgb(162, 241, 192)",
      "200": "rgb(132, 211, 162)",
      "300": "rgb(102, 181, 132)",
      "400": "rgb(72, 151, 102)",
      "500": "rgb(52, 131, 82)",
      "600": "rgb(42, 121, 72)",
      "700": "rgb(32, 111, 62)",
      "800": "rgb(22, 101, 52)",
      "900": "rgb(20, 83, 45)",
      "950": "rgb(27, 50, 36)"
    },
    "warning": {
      "0": "rgb(255, 249, 245)",
      "50": "rgb(255, 244, 236)",
      "100": "rgb(255, 231, 213)",
      "200": "rgb(254, 205, 170)",
      "300": "rgb(253, 173, 116)",
      "400": "rgb(251, 149, 75)",
      "500": "rgb(231, 120, 40)",
      "600": "rgb(215, 108, 31)",
      "700": "rgb(180, 90, 26)",
      "800": "rgb(130, 68, 23)",
      "900": "rgb(108, 56, 19)",
      "950": "rgb(84, 45, 18)"
    },
    "info": {
      "0": "rgb(236, 248, 254)",
      "50": "rgb(199, 235, 252)",
      "100": "rgb(162, 221, 250)",
      "200": "rgb(124, 207, 248)",
      "300": "rgb(87, 194, 246)",
      "400": "rgb(50, 180, 244)",
      "500": "rgb(13, 166, 242)",
      "600": "rgb(11, 141, 205)",
      "700": "rgb(9, 115, 168)",
      "800": "rgb(7, 90, 131)",
      "900": "rgb(5, 64, 93)",
      "950": "rgb(3, 38, 56)"
    },
    "typography": {
      "0": "rgb(254, 254, 255)",
      "50": "rgb(245, 245, 245)",
      "100": "rgb(229, 229, 229)",
      "200": "rgb(219, 219, 220)",
      "300": "rgb(212, 212, 212)",
      "400": "rgb(163, 163, 163)",
      "500": "rgb(140, 140, 140)",
      "600": "rgb(115, 115, 115)",
      "700": "rgb(82, 82, 82)",
      "800": "rgb(64, 64, 64)",
      "900": "rgb(38, 38, 39)",
      "950": "rgb(23, 23, 23)"
    },
    "outline": {
      "0": "rgb(253, 254, 254)",
      "50": "rgb(243, 243, 243)",
      "100": "rgb(230, 230, 230)",
      "200": "rgb(221, 220, 219)",
      "300": "rgb(211, 211, 211)",
      "400": "rgb(165, 163, 163)",
      "500": "rgb(140, 141, 141)",
      "600": "rgb(115, 116, 116)",
      "700": "rgb(83, 82, 82)",
      "800": "rgb(65, 65, 65)",
      "900": "rgb(39, 38, 36)",
      "950": "rgb(26, 23, 23)"
    },
    "background": {
      "0": "rgb(255, 255, 255)",
      "50": "rgb(246, 246, 246)",
      "100": "rgb(242, 241, 241)",
      "200": "rgb(220, 219, 219)",
      "300": "rgb(213, 212, 212)",
      "400": "rgb(162, 163, 163)",
      "500": "rgb(142, 142, 142)",
      "600": "rgb(116, 116, 116)",
      "700": "rgb(83, 82, 82)",
      "800": "rgb(65, 64, 64)",
      "900": "rgb(39, 38, 37)",
      "950": "rgb(18, 18, 18)",
      "error": "rgb(254, 241, 241)",
      "warning": "rgb(255, 243, 234)",
      "success": "rgb(237, 252, 242)",
      "muted": "rgb(247, 248, 247)",
      "info": "rgb(235, 248, 254)"
    },
    "indicator": {
      "primary": "rgb(55, 55, 55)",
      "info": "rgb(83, 153, 236)",
      "error": "rgb(185, 28, 28)"
    }
  },
  {
    "primary": {
      "0": "rgb(230, 241, 251)",
      "50": "rgb(255, 238, 231)",
      "100": "rgb(255, 221, 207)",
      "200": "rgb(255, 203, 182)",
      "300": "rgb(255, 186, 158)",
      "400": "rgb(255, 169, 134)",
      "500": "rgb(255, 152, 110)",
      "600": "rgb(255, 135, 86)",
      "700": "rgb(255, 117, 61)",
      "800": "rgb(255, 100, 37)",
      "900": "rgb(255, 83, 13)",
      "950": "rgb(0, 7, 17)"
    },
    "mark": {
      "900": "rgb(255, 200, 1)"
    },
    "secondary": {
      "0": "rgb(252, 252, 252)",
      "50": "rgb(252, 253, 254)",
      "100": "rgb(243, 244, 246)",
      "200": "rgb(228, 231, 235)",
      "300": "rgb(209, 213, 218)",
      "400": "rgb(156, 163, 175)",
      "500": "rgb(107, 114, 128)",
      "600": "rgb(75, 85, 99)",
      "700": "rgb(55, 65, 81)",
      "800": "rgb(31, 41, 55)",
      "900": "rgb(17, 24, 39)",
      "950": "rgb(0, 0, 0)"
    },
    "tertiary": {
      "0": "rgb(255, 250, 245)",
      "50": "rgb(255, 242, 229)",
      "100": "rgb(255, 233, 213)",
      "200": "rgb(254, 209, 170)",
      "300": "rgb(253, 180, 116)",
      "400": "rgb(251, 157, 75)",
      "500": "rgb(231, 129, 40)",
      "600": "rgb(215, 117, 31)",
      "700": "rgb(180, 98, 26)",
      "800": "rgb(130, 73, 23)",
      "900": "rgb(108, 61, 19)",
      "950": "rgb(84, 49, 18)"
    },
    "error": {
      "0": "rgb(254, 233, 233)",
      "50": "rgb(254, 226, 226)",
      "100": "rgb(254, 202, 202)",
      "200": "rgb(252, 165, 165)",
      "300": "rgb(248, 113, 113)",
      "400": "rgb(239, 68, 68)",
      "500": "rgb(230, 53, 53)",
      "600": "rgb(220, 38, 38)",
      "700": "rgb(185, 28, 28)",
      "800": "rgb(127, 29, 29)",
      "900": "rgb(153, 27, 27)",
      "950": "rgb(34, 8, 8)"
    },
    "success": {
      "0": "rgb(228, 255, 244)",
      "50": "rgb(202, 255, 232)",
      "100": "rgb(162, 241, 192)",
      "200": "rgb(132, 211, 162)",
      "300": "rgb(102, 181, 132)",
      "400": "rgb(72, 151, 102)",
      "500": "rgb(52, 131, 82)",
      "600": "rgb(42, 121, 72)",
      "700": "rgb(32, 111, 62)",
      "800": "rgb(22, 101, 52)",
      "900": "rgb(20, 83, 45)",
      "950": "rgb(27, 50, 36)"
    },
    "warning": {
      "0": "rgb(255, 249, 245)",
      "50": "rgb(255, 244, 236)",
      "100": "rgb(255, 231, 213)",
      "200": "rgb(254, 205, 170)",
      "300": "rgb(253, 173, 116)",
      "400": "rgb(251, 149, 75)",
      "500": "rgb(231, 120, 40)",
      "600": "rgb(215, 108, 31)",
      "700": "rgb(180, 90, 26)",
      "800": "rgb(130, 68, 23)",
      "900": "rgb(108, 56, 19)",
      "950": "rgb(84, 45, 18)"
    },
    "info": {
      "0": "rgb(236, 248, 254)",
      "50": "rgb(199, 235, 252)",
      "100": "rgb(162, 221, 250)",
      "200": "rgb(124, 207, 248)",
      "300": "rgb(87, 194, 246)",
      "400": "rgb(50, 180, 244)",
      "500": "rgb(13, 166, 242)",
      "600": "rgb(11, 141, 205)",
      "700": "rgb(9, 115, 168)",
      "800": "rgb(7, 90, 131)",
      "900": "rgb(5, 64, 93)",
      "950": "rgb(3, 38, 56)"
    },
    "typography": {
      "0": "rgb(254, 254, 255)",
      "50": "rgb(245, 245, 245)",
      "100": "rgb(229, 229, 229)",
      "200": "rgb(219, 219, 220)",
      "300": "rgb(212, 212, 212)",
      "400": "rgb(163, 163, 163)",
      "500": "rgb(140, 140, 140)",
      "600": "rgb(115, 115, 115)",
      "700": "rgb(82, 82, 82)",
      "800": "rgb(64, 64, 64)",
      "900": "rgb(38, 38, 39)",
      "950": "rgb(23, 23, 23)"
    },
    "outline": {
      "0": "rgb(253, 254, 254)",
      "50": "rgb(243, 243, 243)",
      "100": "rgb(230, 230, 230)",
      "200": "rgb(221, 220, 219)",
      "300": "rgb(211, 211, 211)",
      "400": "rgb(165, 163, 163)",
      "500": "rgb(140, 141, 141)",
      "600": "rgb(115, 116, 116)",
      "700": "rgb(83, 82, 82)",
      "800": "rgb(65, 65, 65)",
      "900": "rgb(39, 38, 36)",
      "950": "rgb(26, 23, 23)"
    },
    "background": {
      "0": "rgb(255, 255, 255)",
      "50": "rgb(246, 246, 246)",
      "100": "rgb(242, 241, 241)",
      "200": "rgb(220, 219, 219)",
      "300": "rgb(213, 212, 212)",
      "400": "rgb(162, 163, 163)",
      "500": "rgb(142, 142, 142)",
      "600": "rgb(116, 116, 116)",
      "700": "rgb(83, 82, 82)",
      "800": "rgb(65, 64, 64)",
      "900": "rgb(39, 38, 37)",
      "950": "rgb(18, 18, 18)",
      "error": "rgb(254, 241, 241)",
      "warning": "rgb(255, 243, 234)",
      "success": "rgb(237, 252, 242)",
      "muted": "rgb(247, 248, 247)",
      "info": "rgb(235, 248, 254)"
    },
    "indicator": {
      "primary": "rgb(55, 55, 55)",
      "info": "rgb(83, 153, 236)",
      "error": "rgb(185, 28, 28)"
    }
  },
  {
    "primary": {
      "0": "rgb(230, 241, 251)",
      "50": "rgb(251, 230, 230)",
      "100": "rgb(247, 204, 204)",
      "200": "rgb(243, 179, 179)",
      "300": "rgb(239, 153, 153)",
      "400": "rgb(235, 128, 128)",
      "500": "rgb(230, 102, 102)",
      "600": "rgb(226, 77, 77)",
      "700": "rgb(222, 51, 51)",
      "800": "rgb(218, 26, 26)",
      "900": "rgb(214, 0, 0)",
      "950": "rgb(0, 7, 17)"
    },
    "mark": {
      "900": "rgb(255, 83, 13)"
    },
    "secondary": {
      "0": "rgb(252, 252, 252)",
      "50": "rgb(252, 253, 254)",
      "100": "rgb(243, 244, 246)",
      "200": "rgb(228, 231, 235)",
      "300": "rgb(209, 213, 218)",
      "400": "rgb(156, 163, 175)",
      "500": "rgb(107, 114, 128)",
      "600": "rgb(75, 85, 99)",
      "700": "rgb(55, 65, 81)",
      "800": "rgb(31, 41, 55)",
      "900": "rgb(17, 24, 39)",
      "950": "rgb(0, 0, 0)"
    },
    "tertiary": {
      "0": "rgb(255, 250, 245)",
      "50": "rgb(255, 242, 229)",
      "100": "rgb(255, 233, 213)",
      "200": "rgb(254, 209, 170)",
      "300": "rgb(253, 180, 116)",
      "400": "rgb(251, 157, 75)",
      "500": "rgb(231, 129, 40)",
      "600": "rgb(215, 117, 31)",
      "700": "rgb(180, 98, 26)",
      "800": "rgb(130, 73, 23)",
      "900": "rgb(108, 61, 19)",
      "950": "rgb(84, 49, 18)"
    },
    "error": {
      "0": "rgb(254, 233, 233)",
      "50": "rgb(254, 226, 226)",
      "100": "rgb(254, 202, 202)",
      "200": "rgb(252, 165, 165)",
      "300": "rgb(248, 113, 113)",
      "400": "rgb(239, 68, 68)",
      "500": "rgb(230, 53, 53)",
      "600": "rgb(220, 38, 38)",
      "700": "rgb(185, 28, 28)",
      "800": "rgb(127, 29, 29)",
      "900": "rgb(153, 27, 27)",
      "950": "rgb(34, 8, 8)"
    },
    "success": {
      "0": "rgb(228, 255, 244)",
      "50": "rgb(202, 255, 232)",
      "100": "rgb(162, 241, 192)",
      "200": "rgb(132, 211, 162)",
      "300": "rgb(102, 181, 132)",
      "400": "rgb(72, 151, 102)",
      "500": "rgb(52, 131, 82)",
      "600": "rgb(42, 121, 72)",
      "700": "rgb(32, 111, 62)",
      "800": "rgb(22, 101, 52)",
      "900": "rgb(20, 83, 45)",
      "950": "rgb(27, 50, 36)"
    },
    "warning": {
      "0": "rgb(255, 249, 245)",
      "50": "rgb(255, 244, 236)",
      "100": "rgb(255, 231, 213)",
      "200": "rgb(254, 205, 170)",
      "300": "rgb(253, 173, 116)",
      "400": "rgb(251, 149, 75)",
      "500": "rgb(231, 120, 40)",
      "600": "rgb(215, 108, 31)",
      "700": "rgb(180, 90, 26)",
      "800": "rgb(130, 68, 23)",
      "900": "rgb(108, 56, 19)",
      "950": "rgb(84, 45, 18)"
    },
    "info": {
      "0": "rgb(236, 248, 254)",
      "50": "rgb(199, 235, 252)",
      "100": "rgb(162, 221, 250)",
      "200": "rgb(124, 207, 248)",
      "300": "rgb(87, 194, 246)",
      "400": "rgb(50, 180, 244)",
      "500": "rgb(13, 166, 242)",
      "600": "rgb(11, 141, 205)",
      "700": "rgb(9, 115, 168)",
      "800": "rgb(7, 90, 131)",
      "900": "rgb(5, 64, 93)",
      "950": "rgb(3, 38, 56)"
    },
    "typography": {
      "0": "rgb(254, 254, 255)",
      "50": "rgb(245, 245, 245)",
      "100": "rgb(229, 229, 229)",
      "200": "rgb(219, 219, 220)",
      "300": "rgb(212, 212, 212)",
      "400": "rgb(163, 163, 163)",
      "500": "rgb(140, 140, 140)",
      "600": "rgb(115, 115, 115)",
      "700": "rgb(82, 82, 82)",
      "800": "rgb(64, 64, 64)",
      "900": "rgb(38, 38, 39)",
      "950": "rgb(23, 23, 23)"
    },
    "outline": {
      "0": "rgb(253, 254, 254)",
      "50": "rgb(243, 243, 243)",
      "100": "rgb(230, 230, 230)",
      "200": "rgb(221, 220, 219)",
      "300": "rgb(211, 211, 211)",
      "400": "rgb(165, 163, 163)",
      "500": "rgb(140, 141, 141)",
      "600": "rgb(115, 116, 116)",
      "700": "rgb(83, 82, 82)",
      "800": "rgb(65, 65, 65)",
      "900": "rgb(39, 38, 36)",
      "950": "rgb(26, 23, 23)"
    },
    "background": {
      "0": "rgb(255, 255, 255)",
      "50": "rgb(246, 246, 246)",
      "100": "rgb(242, 241, 241)",
      "200": "rgb(220, 219, 219)",
      "300": "rgb(213, 212, 212)",
      "400": "rgb(162, 163, 163)",
      "500": "rgb(142, 142, 142)",
      "600": "rgb(116, 116, 116)",
      "700": "rgb(83, 82, 82)",
      "800": "rgb(65, 64, 64)",
      "900": "rgb(39, 38, 37)",
      "950": "rgb(18, 18, 18)",
      "error": "rgb(254, 241, 241)",
      "warning": "rgb(255, 243, 234)",
      "success": "rgb(237, 252, 242)",
      "muted": "rgb(247, 248, 247)",
      "info": "rgb(235, 248, 254)"
    },
    "indicator": {
      "primary": "rgb(55, 55, 55)",
      "info": "rgb(83, 153, 236)",
      "error": "rgb(185, 28, 28)"
    }
  }
];
export default inAColors;